import apiClient from './client';

export const ActivityNotCoveredAxiosInstance = apiClient;